import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import * as Components from './components'
import $ from 'jquery'
import CONSTS from './constants'
import EventEmitter from 'eventemitter3'
import objectFitImages from 'object-fit-images'

export default class App {
  constructor(components = []) {
    let i = 0
    const total = components.length
    let Klass = null
    let instance = null

    this.components = []
    this.ev = new EventEmitter()

    this.fallbackObjectFitOrSrcset()

    this.bindResize()

    // init components
    for (i; i < total; i++) {
      Klass = Components[components[i].name]

      if (typeof Klass === 'function') {
        try {
          instance = new Klass(components[i].ctx, this.ev)

          this.components.push({
            name: components[i].name,
            instance,
          })
        } catch (e) {
          console.error(e)
        }
      }
    }
  }

  fallbackObjectFitOrSrcset() {
    if (!window.Modernizr.objectfit || !window.Modernizr.srcset) {
      objectFitImages()
    }
  }

  bindResize() {
    let resizeTimeout = null
    const DELAY = 200

    $(window).on('resize', () => {
      const winWidth = $(window).width()
      const winHeight = $(window).height()

      this.ev.emit(CONSTS.EVENTS.RESIZE, winWidth, winHeight)

      if (resizeTimeout) {
        clearTimeout(resizeTimeout)
      }

      resizeTimeout = window.setTimeout(() => {
        this.ev.emit(CONSTS.EVENTS.RESIZE_DEBOUNCED, winWidth, winHeight)
      }, DELAY)
    })
  }

  run() {
    $(window).trigger('resize')
  }
}
